import React from 'react';

type InputProps = {
  type: 'text' | 'password' | 'number' | 'email' | 'textarea' | 'tel';
  value: string | number;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onBlur?: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  min?: number;
  max?: number;
  rows?: number;
  cols?: number;
  name?: string;
  regex?: RegExp;
  className?: string;
  id?: string;
  style?: React.CSSProperties;
  autoComplete?: string;
  readOnly?: boolean;
  disabled?: boolean;
  custom?: boolean;
  inputMode?:
    | 'numeric'
    | 'search'
    | 'text'
    | 'email'
    | 'tel'
    | 'url'
    | 'none'
    | 'decimal';
};

const Input: React.FC<InputProps> = ({
  type,
  value,
  onChange,
  onBlur,
  onKeyDown,
  onFocus,
  placeholder,
  min,
  max,
  rows,
  cols,
  name,
  regex,
  className,
  id,
  style,
  autoComplete,
  readOnly,
  disabled,
  custom,
  inputMode,
}) => {
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    let newValue = e.target.value;
    if (regex && (type === 'text' || type === 'email')) {
      newValue = newValue.replace(regex, '');
    }
    e.target.value = newValue;
    onChange(e);
  };

  const inputClassName = custom ? 'input--custom' : '';

  return type === 'textarea' ? (
    <textarea
      id={id}
      value={value as string}
      onChange={
        handleInputChange as (e: React.ChangeEvent<HTMLTextAreaElement>) => void
      }
      onBlur={onBlur}
      placeholder={placeholder}
      rows={rows}
      cols={cols}
      name={name}
      className={`input input--${type} ${inputClassName} ${className}`}
      style={style}
    />
  ) : (
    <input
      id={id}
      type={type}
      value={value as string | number}
      onChange={
        handleInputChange as (e: React.ChangeEvent<HTMLInputElement>) => void
      }
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      placeholder={placeholder}
      min={min}
      max={max}
      name={name}
      className={`input input--${type} ${inputClassName} ${className}`}
      style={style}
      autoComplete={autoComplete}
      readOnly={readOnly}
      disabled={disabled}
      inputMode={inputMode}
    />
  );
};

export default Input;
